module.exports = __webpack_public_path__ + "img/icon-minus.c289b935.svg";